/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Section_ExportInputs */



/**
* | output |
* | --- |
* | "File Export" |
*
* @param {Signup_Compare_Section_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_section_export = /** @type {((inputs?: Signup_Compare_Section_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Section_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("File Export")
	if (locale === "de") return /** @type {LocalizedString} */ ("File Export")
	if (locale === "it") return /** @type {LocalizedString} */ ("File Export")
	if (locale === "ru") return /** @type {LocalizedString} */ ("File Export")
	if (locale === "es") return /** @type {LocalizedString} */ ("File Export")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("File Export")
	if (locale === "ja") return /** @type {LocalizedString} */ ("File Export")
	if (locale === "hi") return /** @type {LocalizedString} */ ("File Export")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("File Export")
	return /** @type {LocalizedString} */ ("File Export")
});